HBrandsListToggle.$inject = ['$state', 'hUser'];

function HBrandsListToggle($state, hUser) {
    const self = this;
    self.selectedBrandDetails = {};

    self.toggleBrandsList = () => {
        self.isBrandsListShown = !self.isBrandsListShown;
        self.onDropdownToggle({isBrandsListShown: self.isBrandsListShown});
    };

    const getSelectedBrandDetails = (brandId) => {
        const defer = $q.defer();

        $q.all({
            brandBasicMedia: BrandAPI.getBrandBasicMedia(brandId),
            brandBasicInfo: BrandAPI.getBrandBasicInfo(brandId),
        })
            .then((res) => {
                defer.resolve({
                    image: res.brandBasicMedia?.brand_profile || {},
                    name: res.brandBasicInfo.name,
                })
            })
            .catch((err) => console.error(err));

        return defer.promise;
    };

    const updateSelectedBrandDetails = (activeBrandId) => {
        self.loadingBrandDetails = true;

        getSelectedBrandDetails(activeBrandId)
            .then((res) => {
                self.selectedBrandDetails = res;
            })
            .finally(() => {
                self.loadingBrandDetails = false;
            });
    };

    self.$onInit = () => {
        const platformBrandId = (!hUser.isTopLevelContext() && hUser.data.user.brands_list?.length === 1) ? hUser.data.user.brands_list[0].id : hUser.getEntryMode().brand_id;

        BrandAPI.getBrandBasicMedia(platformBrandId)
            .then((res) => {
                self.platformBrandDetails = {image: res.brand_profile || {}};
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                self.loadingBrandDetails = false;
            });
    };

    self.$onChanges = (changesObj) => {
        if (changesObj.activeBrandId?.currentValue) {
            updateSelectedBrandDetails(changesObj.activeBrandId.currentValue);
        }
    };

    self.isViewingPlatformPage = () => {
        return !!$state.current.platformPage;
    };
}

angular
    .module("harriApp")
    .component("hBrandsListToggle", {
        controller: HBrandsListToggle,
        bindings: {
            activeBrandId: '<',
            isBrandsListShown: '<',
            onDropdownToggle: '&'
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-brands-list-toggle/h-brands-list-toggle.component.html'
    });